<template>
  <div>
    <app-header></app-header>
    <div class="clear"></div>
    <div class="vaacuum"></div>
    <div class="clear"></div>
    <div class="container">
      <div id="searchform">
      <div id="search">
        <div id="search-line-code">
          <div id="search-dot-code">
            <input type="text" id="idnum3" size="3" maxlength="3" value="012" disabled />
          </div>
        </div>
        <div id="search-line">
          <input type="hidden" name="num" id="idnum" />
          <div id="search-dot-white">
            <input type="text" id="idnum1" size="1" maxlength="1" value="2" disabled />
          </div>
          <div id="search-vacuum"></div>
          <div id="search-dot-white">
            <input type="text" id="idnum2" size="1" maxlength="1" value="1" disabled />
          </div>
          <div id="search-vacuum"></div>
          <div id="search-dot-white">
            <input type="text" id="idnum3" size="1" maxlength="1" value="0" disabled />
          </div>
          <div id="search-vacuum"></div>
          <div id="search-dot-blue">
            <input
              type="text"
              id="1"
              size="1"
              maxlength="1"
              v-model="number1"
              @keyup.enter="search"
              @keyup="onlyNumber($event, $event.target.id)"
            />
          </div>
          <div id="search-vacuum"></div>
          <div id="search-dot-blue">
            <input
              type="text"
              id="2"
              size="1"
              maxlength="1"
              v-model="number2"
              @keyup.enter="search"
              @keyup="onlyNumber($event, $event.target.id)"
            />
          </div>
          <div id="search-vacuum"></div>
          <div id="search-dot-blue">
            <input
              type="text"
              id="3"
              size="1"
              maxlength="1"
              v-model="number3"
              @keyup.enter="search"
              @keyup="onlyNumber($event, $event.target.id)"
            />
          </div>
          <div id="search-vacuum"></div>
          <div id="search-dot-blue">
            <input
              type="text"
              id="4"
              size="1"
              maxlength="1"
              v-model="number4"
              @keyup.enter="search"
              @keyup="onlyNumber($event, $event.target.id)"
            />
          </div>
        </div>
        <div id="search-vacuum"></div>
        <div>
          <div id="submit">
            <input @click="search" type="button" name="button" id="button" value="Search" />
          </div>

          <div id="submit">
            <input type="submit" name="button" id="button" value="✕" @click="reset" />
          </div>
        </div>
      </div>
      <div id="search-category">
        <button @click="allNumbers">
          All
          <br />numbers
        </button>
        <button @click="vipNumbers">
          VIP
          <br />numbers
        </button>
        <button @click="category1">Category 1</button>
        <button @click="category2">Category 2</button>
        <button @click="category3">Category 3</button>
        <button @click="category4">Category 4</button>
        <button @click="standardNumbers">
          Standard
          <br />numbers
        </button>
      </div>
    </div>
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">
              Number
              <a
                class="fa fa-fw fa-sort"
                href
                @click="sortByNumber"
                :class="{'fa-sort-down': sortBy=='Number' && orderBy=='Desc', 'fa-sort-up': sortBy=='Number' && orderBy=='Asc'}"
              ></a>
            </th>
            <th scope="col">
              Price
              <a
                class="fa fa-fw fa-sort"
                href
                @click="sortByPrice"
                :class="{'fa-sort-down': sortBy=='Price' && orderBy=='Desc', 'fa-sort-up': sortBy=='Price' && orderBy=='Asc'}"
              ></a>
            </th>
            <th scope="col">Order</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(number, index1) in numbers.slice(0,33)" :key="index1">
            <td>
              <strong>(012) {{ number.number }}</strong>
            </td>
            <td>{{ number.price }} AZN</td>
            <td>
              <a href @click="order($event, number.number)">→</a>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">
              Number
              <a
                class="fa fa-fw fa-sort"
                href
                @click="sortByNumber"
                :class="{'fa-sort-down': sortBy=='Number' && orderBy=='Desc', 'fa-sort-up': sortBy=='Number' && orderBy=='Asc'}"
              ></a>
            </th>
            <th scope="col">
              Price
              <a
                class="fa fa-fw fa-sort"
                href
                @click="sortByPrice"
                :class="{'fa-sort-down': sortBy=='Price' && orderBy=='Desc', 'fa-sort-up': sortBy=='Price' && orderBy=='Asc'}"
              ></a>
            </th>
            <th scope="col">Order</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(number, index1) in numbers.slice(33,66)" :key="index1">
            <td>
              <strong>(012) {{ number.number }}</strong>
            </td>
            <td>{{ number.price }} AZN</td>
            <td>
              <a href @click="order($event, number.number)">→</a>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">
              Number
              <a
                class="fa fa-fw fa-sort"
                href
                @click="sortByNumber"
                :class="{'fa-sort-down': sortBy=='Number' && orderBy=='Desc', 'fa-sort-up': sortBy=='Number' && orderBy=='Asc'}"
              ></a>
            </th>
            <th scope="col">
              Price
              <a
                class="fa fa-fw fa-sort"
                href
                @click="sortByPrice"
                :class="{'fa-sort-down': sortBy=='Price' && orderBy=='Desc', 'fa-sort-up': sortBy=='Price' && orderBy=='Asc'}"
              ></a>
            </th>
            <th scope="col">Order</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(number, index1) in numbers.slice(66,99)" :key="index1">
            <td>
              <strong>(012) {{ number.number }}</strong>
            </td>
            <td>{{ number.price }} AZN</td>
            <td>
              <a href @click="order($event, number.number)">→</a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="clear"></div>

      <h1 class="paginationHeader" v-if="notExist">The number does not exist</h1>

      <nav aria-label="..." class="paginationHeader">
        <ul class="pagination pagination-lg">
          <li class="page-item" :class="{disabled: pageNumber == 1}">
            <a class="page-link" href @click.stop="changePage($event, pageNumber2)"><<</a>
          </li>
          <li class="page-item" v-if="pageNumber > 3">
            <a class="page-link" href @click.stop="changePage($event, 1)">1</a>
          </li>
          <li class="page-item" v-if="pageNumber>5">
            <a class="page-link" href>...</a>
          </li>
          <li class="page-item" v-if="pageNumber==5">
            <a class="page-link" href @click.stop="changePage($event, 2)">2</a>
          </li>
          <li class="page-item" v-if="pageNumber>2">
            <a class="page-link" href @click.stop="changePage($event, pageNumber1)">{{pageNumber1}}</a>
          </li>
          <li class="page-item" v-if="pageNumber>1">
            <a class="page-link" href @click.stop="changePage($event, pageNumber2)">{{ pageNumber2}}</a>
          </li>
          <li class="page-item active">
            <span class="page-link">
              {{pageNumber}}
              <span class="sr-only">(current)</span>
            </span>
          </li>
          <li class="page-item" v-if="pageNumber < lastPage">
            <a class="page-link" href @click.stop="changePage($event, pageNumber3)">{{pageNumber3}}</a>
          </li>
          <li class="page-item" v-if="pageNumber < lastPage - 1">
            <a class="page-link" href @click.stop="changePage($event, pageNumber4)">{{pageNumber4}}</a>
          </li>
          <li class="page-item" v-if="pageNumber < lastPage - 4">
            <a class="page-link" href>...</a>
          </li>
          <li class="page-item" v-if="pageNumber == lastPage - 4">
            <a
              class="page-link"
              href
              @click.stop="changePage($event, lastPage - 1)"
            >{{ lastPage - 1 }}</a>
          </li>
          <li class="page-item">
            <a
              class="page-link"
              href
              v-if="pageNumber < lastPage - 2"
              @click.stop="changePage($event, lastPage)"
            >{{ lastPage }}</a>
          </li>
          <li class="page-item" :class="{disabled: pageNumber >= lastPage}">
            <a class="page-link" href @click.stop="changePage($event, pageNumber3)">>></a>
          </li>
        </ul>
      </nav>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import axios from "axios";
import appHeader from "./Header.vue";
import appFooter from "./Footer.vue";
import { store } from "../../store.js";
export default {
  components: {
    appHeader,
    appFooter,
  },
  methods: {
    sortByNumber: function () {
      var orderBy = this.orderBy == "Desc" ? "Asc" : "Desc";
      this.$router.push(
        "/en/sip/" +
          this.id +
          "/" +
          this.pageNumber +
          "/" +
          "Number" +
          "/" +
          orderBy
      );
    },
    sortByPrice: function () {
      var orderBy = this.orderBy == "Desc" ? "Asc" : "Desc";
      this.$router.push(
        "/en/sip/" +
          this.id +
          "/" +
          this.pageNumber +
          "/" +
          "Price" +
          "/" +
          orderBy
      );
    },
    changePage: function (event, page) {
      if(page > 0 && page <= this.lastPage)
      this.$router.push(
        "/en/sip/" +
          this.id +
          "/" +
          page +
          "/" +
          this.sortBy +
          "/" +
          this.orderBy
      );
    },
    order: function (event, number) {
      this.$router.push("/en/sip/order/" + number);
    },
    onlyNumber: function ($event, id) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ($event.key == "Backspace")
        document.getElementById(parseInt(id) - 1).focus();
      else if ((keyCode < 48 || keyCode > 57) && (keyCode < 96 || keyCode > 105)) {
        document.getElementById(parseInt(id)).value = '';
      } else {
        if (document.getElementById(parseInt(id) + 1).value == "")
          document.getElementById(parseInt(id) + 1).focus();
      }
    },
    search: function () {
      if (this.number1 == "") this.number1 = "x";
      if (this.number2 == "") this.number2 = "x";
      if (this.number3 == "") this.number3 = "x";
      if (this.number4 == "") this.number4 = "x";
      store.convert(true);
      this.$router.push(
        "/en/sip/210" +
          this.number1 +
          this.number2 +
          this.number3 +
          this.number4 +
          "/1/Price/Desc"
      );
      if (this.number1 == "x") this.number1 = "";
      if (this.number2 == "x") this.number2 = "";
      if (this.number3 == "x") this.number3 = "";
      if (this.number4 == "x") this.number4 = "";
    },
    allNumbers: function () {
      store.convert(true);
      this.$router.push("/en/sip/all/1/Price/Desc");
    },
    vipNumbers: function () {
      store.convert(true);
      this.$router.push("/en/sip/VIP/1/Price/Desc");
    },
    category1: function () {
      store.convert(true);
      this.$router.push("/en/sip/1st/1/Price/Desc");
    },
    category2: function () {
      store.convert(true);
      this.$router.push("/en/sip/2nd/1/Price/Desc");
    },
    category3: function () {
      store.convert(true);
      this.$router.push("/en/sip/3rd/1/Price/Desc");
    },
    category4: function () {
      store.convert(true);
      this.$router.push("/en/sip/4th/1/Price/Desc");
    },
    standardNumbers: function () {
      store.convert(true);
      this.$router.push("/en/sip/standard/1/Price/Desc");
    },
    reset: function () {
      this.number1 = "";
      this.number2 = "";
      this.number3 = "";
      this.number4 = "";
    },
  },
  data: function () {
    return {
      link: "",
      linkTotalNumber: "",
      numbers: null,
      id: this.$route.params.id,
      number1: "",
      number2: "",
      number3: "",
      number4: "",
      pageNumber: 20,
      pageNumber1: 0,
      pageNumber2: 0,
      pageNumber3: 0,
      pageNumber4: 0,
      lastPage: 1,
      sortBy: this.$route.params.sortBy,
      orderBy: this.$route.params.orderBy,
      notExist: false,
    };
  },
  created: function () {
    this.pageNumber = parseInt(this.$route.params.pageNumber);
    this.pageNumber1 = this.pageNumber - 2;
    this.pageNumber2 = this.pageNumber - 1;
    this.pageNumber3 = this.pageNumber + 1;
    this.pageNumber4 = this.pageNumber + 2;
    if (this.id[1] == "1") {
      this.number1 = this.id[3];
      this.number2 = this.id[4];
      this.number3 = this.id[5];
      this.number4 = this.id[6];

      this.link =
        "https://apisip.azcloud.az/api/v1/Number?" +
        "pageNumber=" +
        this.pageNumber +
        "&sortBy=" +
        this.sortBy +
        "&orderBy=" +
        this.orderBy;
      this.link =
        this.link + (this.number1 != "x" ? "&number1=" + this.number1 : "");
      this.link =
        this.link + (this.number2 != "x" ? "&number2=" + this.number2 : "");
      this.link =
        this.link + (this.number3 != "x" ? "&number3=" + this.number3 : "");
      this.link =
        this.link + (this.number4 != "x" ? "&number4=" + this.number4 : "");
      this.link =
        this.link + (store.flag == true ? "&flag=true" : "&flag=false");
      this.linkTotalNumber = this.link.replace(
        "/api/v1/Number",
        "/api/v1/NumberTotalCount"
      );
    } else {
      this.link =
        "https://apisip.azcloud.az/api/v1/Category?category=" +
        this.id +
        "&sortBy=" +
        this.sortBy +
        "&orderBy=" +
        this.orderBy +
        "&pageNumber=" +
        this.pageNumber;
      this.link =
        this.link + (store.flag == true ? "&flag=true" : "&flag=false");
      this.linkTotalNumber = this.link.replace(
        "/api/v1/Category",
        "/api/v1/CategoryTotalCount"
      );
    }
    axios
      .get(this.link, {})
      .then((response) => {
        this.numbers = response.data;
      })
      .catch((error) => console.log(error));
    axios
      .get(this.linkTotalNumber, {})
      .then((response) => {
        if (response.data == 0) this.notExist = true;
        this.lastPage = response.data;
        this.lastPage = Math.ceil(this.lastPage / 99);
      })
      .catch((error) => console.log(error));

    store.convert(false);
    if (this.number1 == "x") this.number1 = "";
    if (this.number2 == "x") this.number2 = "";
    if (this.number3 == "x") this.number3 = "";
    if (this.number4 == "x") this.number4 = "";
  },
};
</script>

<style scoped>
/* bootstrap links colors*/
.pagination > li > span > .sr-only {
  color: white;
  /* use your own color here  */
}
.pagination > li > a {
  color: #163766;
}

.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  background-color: #163766;
  border-color: #163766;
}

.paginationHeader {
  text-align: center;
}
table {
  margin-top: 10px;
  width: 350px;
  float: left;
  margin-left: 20px;
}
.clear {
  clear: both;
}

#search-category {
  width: 800px;
  float: left;
  position: relative;
  left: 179px;
}
#search-category button {
  width: 100px;
  height: 50px;
  color: #ffffff;
  margin-left: 10px;
  margin-top: 10px;
  float: left;
  background-color: #29b8fd;
  border: 2px solid #29b8fd;
  border-radius: 5px;
}
#search-category button:hover {
  background-color: #120ed1;
  border: 2px solid #120ed1;
  color: #fff;
  opacity: 1;
}

input[type="text"]:disabled {
  background-color: #acb1b6;
}
#container {
  width: 100%;
}
#search {
  width: 785px;
  height: 75px;
  background-color: #18396a;
  border-radius: 5px;
  padding: 12px;
  margin: 0 auto;
}

#search-line-submit input:focus,
#search-line-submit input:focus {
  border: 2px solid #120ed1;
  cursor: pointer;
  color: #120ed1;
  opacity: 1;
  outline: none;
}

#search-line input:hover,
#search-line input:focus {
  cursor: pointer;
  opacity: 1;
  outline: none;
}

#search-line-code input:hover,
#search-line-code input:focus {
  cursor: pointer;
  opacity: 1;
  outline: none;
}

/* SUBMIT */
#submit {
  width: 115px;
  float: left;
}
#submit input {
  width: 100px;
  height: 50px;
  font: normal 1.8em/1.2em Arial, Helvetica, sans-serif;
  padding: 2px;
  border-radius: 5px;
  border: 2px solid #100d9c;
  background-color: #fff;
  color: #120ed1;
  opacity: 0.95;
}
#submit input:hover {
  background-color: #29b8fd;
  color: #fff;
  opacity: 1;
}

/* SEARCH-LINE-SUBMIT */
#search-line-submit {
  width: 250px;
  float: left;
  margin-left: 10px;
}

#search-line-submit input {
  width: 100px;
  height: 40px;
  border: 2px solid #120ed1;
  font: normal 1.8em/1.4em Arial, Helvetica, sans-serif;
  padding: 2px;
  text-align: center;
  margin-right: 5px;
  border-radius: 5px;
  color: #120ed1;
  opacity: 0.95;
}
#search-dot-submit {
  float: left;
}
#search-dot-reset {
  float: left;
}

/* SEARCH-LINE-CODE */
#search-line-code {
  width: 85px;
  float: left;
  margin-left: 10px;
}
#search-line-code input {
  width: 80px;
  height: 50px;
  border: 2px solid #100d9c;
  font: normal 1.8em/1.4em Arial, Helvetica, sans-serif;
  padding: 2px;
  text-align: center;
  margin-right: 5px;
  border-radius: 5px;
  color: #fff;
  opacity: 0.95;
}
#search-dot-code {
  float: left;
}

/* SEARCH-LINE */
#search-line {
  width: 415px;
  float: left;
  margin-left: 10px;
}
#search-line input {
  width: 50px;
  height: 50px;
  border: 2px solid #100d9c;
  font: normal 1.8em/1.4em Arial, Helvetica, sans-serif;
  padding: 2px;
  text-align: center;
  /* margin-right: 5px; */
  border-radius: 5px;

  opacity: 0.95;
}
#search-dot-white {
  float: left;
  color: #fff;
}
#search-dot-blue {
  float: left;
  color: #100d9c;
}

/* CLEAR */
.clear {
  clear: both;
}
#clear {
  clear: both;
}

/* CENTER */
#center {
  width: 806px;
  margin: 0 auto;
}
#center .logo {
  margin: 0 auto;
  width: 350px;
  height: 140px;
}
#center .search {
  height: 45px;
  width: 555px;
  margin-top: 20px;
}

/* vacuum */
#search-vacuum {
  width: 10px;
  height: 30px;
  float: left;
  border: #fff;
}
.vaacuum {
  height: 20px;
  width: 100%;
  border: 0;
  clear: both;
}
.vaacuum_75 {
  height: 75px;
  width: 100%;
  border: 0;
  clear: both;
}
.vaacuum_50 {
  height: 50px;
  width: 100%;
  border: 0;
  clear: both;
}

/* reset */
#reset {
  width: 55px;
  height: 40px;
  position: relative;
  left: 600px;
  bottom: 93px;
}

#reset input {
  width: 70px;
  height: 40px;
  font: normal 2em/1.2em Arial, Helvetica, sans-serif;
  padding: 2px;
  border-radius: 5px;
  border: 2px solid #633493;
  background-color: #fff;
  color: #633493;
  opacity: 0.95;
}
#reset input:focus,
#reset input:hover {
  border: 2px solid #633493;
  cursor: pointer;
  background-color: #fff;
  color: #633493;
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/EN/Sip.vue